export const measurementFillColor = "rgba(0, 191, 255, 0.15)";
export const measurementPointColor = "rgba(0, 191, 255, 0.75)";
export const measurementLineColor = "rgba(255, 255, 0, 1)";
export const measurementInactiveFillColor = "rgba(0, 191, 255, 0.075)";
export const measurementInactivePointColor = "rgba(0, 191, 255, 0.25)";
export const measurementInactiveLineColor = "rgba(255, 255, 0, 0.4)";
export const hoverFillColor = "rgba(0, 170, 200, 0.3)";
export const hoverLineColor = "rgba(255, 165, 0, 1)";
